import { Icon } from '@iconify/react';
import {
    Card,
    StatTitle,
    StatValue,
    StatMetaRow,
    Mono,
    MetaMuted
} from '../styles/OverviewStyle';
import type React from 'react';

interface StatCardProps {
   title: string;
   value: string;
   meta?: string;
   link?: boolean;
   change?: string;
   changePositive?: boolean | undefined;
}

const StatCard = ({ title, value, change, changePositive = true, meta, link }: StatCardProps): React.JSX.Element => {
   const getIcon = () => {
      if (changePositive === undefined) return 'solar:minus-circle-bold';
      return changePositive ? 'solar:arrow-up-bold' : 'solar:arrow-down-bold';
   };

   return (
      <Card>
         <StatTitle>{title}</StatTitle>
         <StatValue>{value}</StatValue>
   
         {(change || meta) && (
            <StatMetaRow>
               {change && (
                  <Mono changePositive={changePositive}>
                     <Icon
                        width={10}
                        icon={getIcon()}
                        style={{ aspectRatio: '1/1' }}
                     />
                     <span>{change}</span>
                  </Mono>
               )}
               {meta && <MetaMuted change={!!change} link={!!link}>{meta}</MetaMuted>}
               {link && <Icon icon='fluent:ios-arrow-right-24-filled' className='w-2.5 text-[#9C9C9F]' />}
            </StatMetaRow>
         )}
      </Card>
   );
};

export default StatCard;